import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import CommonModule from 'common';

import ConversionQuizComponent from './conversion-quiz.cmpt';
import WelcomeComponent from './steps/welcome/welcome.cmpt';
import StrugglesComponent from './steps/struggles/struggles.cmpt';
import TrackingComponent from './steps/tracking/tracking.cmpt';
import GoalComponent from './steps/goal/goal.cmpt';
import SuggestionComponent from './steps/suggestion/suggestion.cmpt';
import PlansComponent from './steps/plans/plans.cmpt';
import RegisterComponent from './steps/register/register.cmpt';
import DownloadComponent from './steps/download/download.cmpt';

// Import required services
import SessionService from 'application/service/session.service';
import PaymentService from 'application/service/payment/payment.service';

export default angular
    .module('presentation.scene.conversion-quiz', [
        uiRouter,
        CommonModule.name
    ])
    .service('sessionService', SessionService)
    .service('paymentService', PaymentService)
    .run(['apiService', (apiService) => {
        // Temporarily set API URL for testing
        apiService.api = 'https://api.dollarbird.co/v1';
    }])
    .component('dbConversionQuiz', ConversionQuizComponent)
    .component('dbQuizWelcome', WelcomeComponent)
    .component('dbQuizStruggles', StrugglesComponent)
    .component('dbQuizTracking', TrackingComponent)
    .component('dbQuizGoal', GoalComponent)
    .component('dbQuizSuggestion', SuggestionComponent)
    .component('dbQuizPlans', PlansComponent)
    .component('dbQuizRegister', RegisterComponent)
    .component('dbQuizDownload', DownloadComponent)
    .config(routerConfiguration);

/* @ngInject */
function routerConfiguration($stateProvider, $urlRouterProvider) {
    // Redirect /start to /start/welcome
    $urlRouterProvider.when('/start', '/start/welcome');

    $stateProvider
        .state('conversion-quiz', {
            url: '/start',
            component: 'dbConversionQuiz',
            data: {
                title: 'Find Your Perfect Financial Tool'
            }
        })
        .state('conversion-quiz.welcome', {
            url: '/welcome',
            component: 'dbQuizWelcome'
        })
        .state('conversion-quiz.struggles', {
            url: '/struggles',
            component: 'dbQuizStruggles'
        })
        .state('conversion-quiz.tracking', {
            url: '/current-tracking',
            component: 'dbQuizTracking'
        })
        .state('conversion-quiz.goal', {
            url: '/goal',
            component: 'dbQuizGoal'
        })
        .state('conversion-quiz.suggestion', {
            url: '/suggestion',
            component: 'dbQuizSuggestion'
        })
        // Temporarily disabled plans step
        // .state('conversion-quiz.plans', {
        //     url: '/plans',
        //     component: 'dbQuizPlans'
        // })
        .state('conversion-quiz.register', {
            url: '/register',
            component: 'dbQuizRegister'
        })
        .state('conversion-quiz.download', {
            url: '/download',
            component: 'dbQuizDownload'
        });
}



// WEBPACK FOOTER //
// ./src/presentation/scene/conversion-quiz/index.js